import { compose, withHandlers, withProps, withState } from 'recompose';

const ProductsStepContainer = compose(
  withState('selectedVendorIds', 'setSelectedVendorIds', []),
  withHandlers({
    handleVendorsChange: props => (selectedVendorIds) => {
      props.setSelectedVendorIds(selectedVendorIds);
    },
  }),
  withProps((props) => {
    const allProducts = props.products.filter(
      product => props.vendors.some(vendor => vendor.id === product.vendorId)
    );
    return {
      vendorOptions: props.vendors
        .map(vendor => ({
          value: vendor.id,
          label: vendor.name,
        })),
      products: allProducts,
      filteredProducts: props.selectedVendorIds.length
        ? allProducts.filter(product => props.selectedVendorIds.includes(product.vendorId))
        : allProducts,
    };
  }),
);

export default ProductsStepContainer;
